"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _contexts = require("../contexts");
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* 
This component is tested at FormBuilder level 
Check tests at FormBuilder/__tests__/FormBuilder.unit.test.jsx
*/
var FieldWrapper = _ref => {
  var {
    children
  } = _ref;
  var {
    spacing: formSpacing
  } = (0, _react.useContext)(_contexts.AppContext);
  var {
    testSpacing
  } = (0, _react.useContext)(_contexts.StorybookContext);
  var spacing = testSpacing || formSpacing;
  var topPaddingValue = spacing === _constants.FORM_SPACING.COMPACT ? 4 : spacing === _constants.FORM_SPACING.LOOSE ? 7 : 5;
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    top: topPaddingValue,
    testID: "form-builder-field-wrapper"
  }, children);
};
FieldWrapper.propTypes = {
  children: _propTypes.default.node
};
var _default = exports.default = FieldWrapper;